export class ConnectArrayTemplate {
  constructor(public $implicit: any, public index: number, public item: any) {}
}
